import { Injectable, InjectionToken } from "@angular/core";
import { SeedRequest } from "../../shared/services/seed-request.service";
import { ActivatedRoute } from "@angular/router";

export const SEED_REQUESTS = new InjectionToken('route resolved seed requests');

@Injectable()
export class ResolvedSeedRequestsService {
    public seedRequests: SeedRequest[];

    constructor(private activatedRoute: ActivatedRoute) {
        this.activatedRoute
            .data
            .subscribe(d => {
                this.seedRequests = d.seedRequests;
            })
    }
}

export interface ResolvedSeedRequests {
    seedRequests: SeedRequest[];
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/services/resolved-seed-requests.module.ts